import { Component, OnInit } from '@angular/core';
import { PaymentLibService } from '../payment-lib.service';
import { Ticket } from 'core-lib';
import {OrderListSelectionChangeEvent} from "primeng/orderlist";

@Component({
    selector: 'lib-payment-wallet',
    templateUrl: './payment-wallet.component.html',
    styleUrls: ['./payment-wallet.component.scss'],
    standalone: false
})
export class PaymentWalletComponent implements OnInit {

    walletElements: Ticket[] = [];
    filteredWalletElements: Ticket[] = [];
    searchInput: string;
    selectedWalletElement: Ticket;
    dialogControl={
        showProductDetails: false
    }

    constructor(private paymentService: PaymentLibService){

    }

    ngOnInit(): void {
        this.paymentService.loadWallet().subscribe((result)=>{
            this.walletElements = result;
            this.filteredWalletElements = result;
        });
    }

    onWalletElementClicked(element: Ticket): void{
        this.selectedWalletElement = element;
        this.dialogControl.showProductDetails = true;
    }

    onFilterInput(): void {
        this.filteredWalletElements = this.walletElements.filter(item => {
            return item.product.name.toLowerCase().includes(this.searchInput.toLowerCase());
        })
    }
}
